export default __webpack_public_path__ + "static/media/benoit-bertet.0057c34a.jpg";